"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "data": [
        {
            "clientAccountKey": "ca_e57f2ba6d7f24aa1800dd40ac3565cf2",
            "name": "Mock ClientAccount",
            "type": "Individual",
            "status": "Pending",
            "adviserName": "Mock AdviserName"
        }
    ],
    "totalRecords": 1,
    "skip": 0,
    "take": 1,
    "recordsReturned": 1
};
